"use strict";
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncDelegator = (this && this.__asyncDelegator) || function (o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
};
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeploymentFields = exports.ContentClient = void 0;
const dcl_catalyst_commons_1 = require("dcl-catalyst-commons");
const async_iterator_to_array_1 = __importDefault(require("async-iterator-to-array"));
const stream_1 = require("stream");
const Helper_1 = require("./utils/Helper");
const form_data_1 = __importDefault(require("form-data"));
class ContentClient {
    constructor(contentUrl, origin, // The name or a description of the app that is using the client
    fetcher) {
        this.origin = origin;
        this.KNOWN_HEADERS = [
            'Content-Type',
            'Access-Control-Allow-Origin',
            'Access-Control-Expose-Headers',
            'ETag',
            'Date',
            'Content-Length',
            'Cache-Control'
        ];
        this.contentUrl = Helper_1.sanitizeUrl(contentUrl);
        this.fetcher =
            fetcher !== null && fetcher !== void 0 ? fetcher : new dcl_catalyst_commons_1.Fetcher({
                headers: Helper_1.getHeadersWithUserAgent('content-client')
            });
    }
    async deployEntity(deployData, fix = false, options) {
        // Check if we are running in node or browser
        const areWeRunningInNode = Helper_1.isNode();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const form = areWeRunningInNode ? new form_data_1.default() : new FormData();
        form.append('entityId', deployData.entityId);
        Helper_1.addModelToFormData(deployData.authChain, form, 'authChain');
        const alreadyUploadedHashes = await this.hashesAlreadyOnServer(Array.from(deployData.files.keys()), options);
        for (const [fileHash, file] of deployData.files) {
            if (!alreadyUploadedHashes.has(fileHash) || fileHash === deployData.entityId) {
                if (areWeRunningInNode) {
                    // Node
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    form.append(file.name, file.content, file.name);
                }
                else {
                    // Browser
                    form.append(file.name, new Blob([file.content.buffer]), file.name);
                }
            }
        }
        const requestOptions = dcl_catalyst_commons_1.mergeRequestOptions(options !== null && options !== void 0 ? options : {}, {
            body: form,
            headers: { 'x-upload-origin': this.origin }
        });
        const { creationTimestamp } = await this.fetcher.postForm(`${this.contentUrl}/entities${fix ? '?fix=true' : ''}`, requestOptions);
        return creationTimestamp;
    }
    fetchEntitiesByPointers(type, pointers, options) {
        if (pointers.length === 0) {
            return Promise.reject(`You must set at least one pointer.`);
        }
        return Helper_1.splitAndFetch({
            fetcher: this.fetcher,
            baseUrl: this.contentUrl,
            path: `/entities/${type}`,
            queryParams: { name: 'pointer', values: pointers },
            uniqueBy: 'id',
            options
        });
    }
    fetchEntitiesByIds(type, ids, options) {
        if (ids.length === 0) {
            return Promise.reject(`You must set at least one id.`);
        }
        return Helper_1.splitAndFetch({
            fetcher: this.fetcher,
            baseUrl: this.contentUrl,
            path: `/entities/${type}`,
            queryParams: { name: 'id', values: ids },
            uniqueBy: 'id',
            options
        });
    }
    async fetchEntityById(type, id, options) {
        const entities = await this.fetchEntitiesByIds(type, [id], options);
        if (entities.length === 0) {
            return Promise.reject(`Failed to find an entity with type '${type}' and id '${id}'.`);
        }
        return entities[0];
    }
    fetchAuditInfo(type, id, options) {
        return this.fetchJson(`/audit/${type}/${id}`, options);
    }
    fetchContentStatus(options) {
        return this.fetchJson('/status', options);
    }
    async downloadContent(contentHash, options) {
        const { attempts = 3, waitTime = '0.5s' } = options !== null && options !== void 0 ? options : {};
        const timeout = (options === null || options === void 0 ? void 0 : options.timeout) ? { timeout: options.timeout } : {};
        return dcl_catalyst_commons_1.retry(async () => {
            const content = await this.fetcher.fetchBuffer(`${this.contentUrl}/contents/${contentHash}`, timeout);
            const downloadedHash = await dcl_catalyst_commons_1.Hashing.calculateBufferHash(content);
            // Sometimes, the downloaded file is not complete, so the hash turns out to be different.
            // So we will check the hash before considering the download successful.
            if (downloadedHash === contentHash) {
                return content;
            }
            throw new Error(`Failed to fetch file with hash ${contentHash} from ${this.contentUrl}`);
        }, attempts, waitTime);
    }
    async pipeContent(contentHash, writeTo, options) {
        return this.onlyKnownHeaders(await this.fetcher.fetchPipe(`${this.contentUrl}/contents/${contentHash}`, writeTo, options));
    }
    fixHeaderNameCase(headerName) {
        return this.KNOWN_HEADERS.find((item) => item.toLowerCase() === headerName.toLowerCase());
    }
    onlyKnownHeaders(headersFromResponse) {
        const headers = new Map();
        headersFromResponse === null || headersFromResponse === void 0 ? void 0 : headersFromResponse.forEach((headerValue, headerName) => {
            const fixedHeader = this.fixHeaderNameCase(headerName);
            if (fixedHeader) {
                headers.set(fixedHeader, headerValue);
            }
        });
        return headers;
    }
    /**
     * This method fetches all deployments that match the given filters.
     *  It is important to mention, that if there are too many filters, then the URL might get too long.
     *  In that case, we will internally make the necessary requests,
     *  but then the order of the deployments is not guaranteed.
     */
    fetchAllDeployments(deploymentOptions, options) {
        return async_iterator_to_array_1.default(this.iterateThroughDeployments(deploymentOptions, options));
    }
    streamAllDeployments(deploymentOptions, options) {
        return stream_1.Readable.from(this.iterateThroughDeployments(deploymentOptions, options));
    }
    iterateThroughDeployments(deploymentOptions, options) {
        var _a;
        return __asyncGenerator(this, arguments, function* iterateThroughDeployments_1() {
            // We are setting different defaults in this case, because if one of the request fails, then all fail
            const withSomeDefaults = dcl_catalyst_commons_1.applySomeDefaults({ attempts: 3, waitTime: '1s' }, options);
            // Validate that some params were used, so that not everything is fetched
            this.assertFiltersAreSet(deploymentOptions === null || deploymentOptions === void 0 ? void 0 : deploymentOptions.filters);
            // Transform filters object into query params map
            const filterQueryParams = Helper_1.convertFiltersToQueryParams(deploymentOptions === null || deploymentOptions === void 0 ? void 0 : deploymentOptions.filters);
            // Transform sorting object into query params map
            const sortingQueryParams = this.sortingToQueryParams(deploymentOptions === null || deploymentOptions === void 0 ? void 0 : deploymentOptions.sortBy);
            // Initialize query params with filters and sorting
            const queryParams = new Map([...filterQueryParams, ...sortingQueryParams]);
            if (deploymentOptions === null || deploymentOptions === void 0 ? void 0 : deploymentOptions.fields) {
                const fieldsValue = deploymentOptions === null || deploymentOptions === void 0 ? void 0 : deploymentOptions.fields.getFields();
                queryParams.set('fields', [fieldsValue]);
            }
            let reservedParams;
            let modifyQueryBasedOnResult;
            const canWeUseLocalTimestampInsteadOfOffset = (deploymentOptions === null || deploymentOptions === void 0 ? void 0 : deploymentOptions.fields) &&
                deploymentOptions.fields.isFieldIncluded('auditInfo') &&
                (!(deploymentOptions === null || deploymentOptions === void 0 ? void 0 : deploymentOptions.sortBy) || deploymentOptions.sortBy.field === dcl_catalyst_commons_1.SortingField.LOCAL_TIMESTAMP);
            if (canWeUseLocalTimestampInsteadOfOffset) {
                // Note: the approach used below will get stuck if all 500 deployments on the same page have the same localTimestamp, but that is extremely unlikely
                reservedParams = new Map([
                    ['fromLocalTimestamp', 13],
                    ['toLocalTimestamp', 13]
                ]);
                if (((_a = deploymentOptions === null || deploymentOptions === void 0 ? void 0 : deploymentOptions.sortBy) === null || _a === void 0 ? void 0 : _a.order) === dcl_catalyst_commons_1.SortingOrder.ASCENDING) {
                    // Ascending
                    modifyQueryBasedOnResult = (result, builder) => this.setParamBasedOnResult('fromLocalTimestamp', result, builder);
                }
                else {
                    // Descending
                    modifyQueryBasedOnResult = (result, builder) => this.setParamBasedOnResult('toLocalTimestamp', result, builder);
                }
            }
            else {
                // We will use offset then
                reservedParams = new Map([['offset', ContentClient.CHARS_LEFT_FOR_OFFSET]]);
                modifyQueryBasedOnResult = (result, queryBuilder) => queryBuilder.setParam('offset', result.pagination.limit + result.pagination.offset);
            }
            yield __await(yield* __asyncDelegator(__asyncValues(this.iterateThroughDeploymentsBasedOnResult(queryParams, reservedParams, modifyQueryBasedOnResult, deploymentOptions === null || deploymentOptions === void 0 ? void 0 : deploymentOptions.errorListener, withSomeDefaults))));
        });
    }
    iterateThroughDeploymentsBasedOnResult(queryParams, reservedParams, modifyQueryBasedOnResult, errorListener, options) {
        return __asyncGenerator(this, arguments, function* iterateThroughDeploymentsBasedOnResult_1() {
            // Split values into different queries
            const builders = Helper_1.splitValuesIntoManyQueryBuilders({
                baseUrl: this.contentUrl,
                path: '/deployments',
                queryParams,
                reservedParams
            });
            // Perform the different queries
            const foundIds = new Set();
            let exit = false;
            for (let i = 0; i < builders.length && !exit; i++) {
                const queryBuilder = builders[i];
                let keepRetrievingHistory = true;
                while (keepRetrievingHistory && !exit) {
                    const url = queryBuilder.toString();
                    try {
                        const partialHistory = yield __await(this.fetcher.fetchJson(url, options));
                        for (const deployment of partialHistory.deployments) {
                            if (!foundIds.has(deployment.entityId)) {
                                foundIds.add(deployment.entityId);
                                yield yield __await(deployment);
                            }
                        }
                        modifyQueryBasedOnResult(partialHistory, queryBuilder);
                        keepRetrievingHistory = partialHistory.pagination.moreData;
                    }
                    catch (error) {
                        if (errorListener) {
                            errorListener(`${error}`);
                        }
                        exit = true;
                    }
                }
            }
        });
    }
    setParamBasedOnResult(paramName, result, builder) {
        const lastDeployment = result.deployments[result.deployments.length - 1];
        if (lastDeployment) {
            // @ts-ignore
            builder.setParam(paramName, lastDeployment.auditInfo.localTimestamp);
        }
    }
    assertFiltersAreSet(filters) {
        const filtersAreSet = (filters === null || filters === void 0 ? void 0 : filters.fromLocalTimestamp) ||
            (filters === null || filters === void 0 ? void 0 : filters.toLocalTimestamp) ||
            ((filters === null || filters === void 0 ? void 0 : filters.deployedBy) && (filters === null || filters === void 0 ? void 0 : filters.deployedBy.length) > 0) ||
            ((filters === null || filters === void 0 ? void 0 : filters.entityTypes) && (filters === null || filters === void 0 ? void 0 : filters.entityTypes.length) > 0) ||
            ((filters === null || filters === void 0 ? void 0 : filters.entityIds) && (filters === null || filters === void 0 ? void 0 : filters.entityIds.length) > 0) ||
            ((filters === null || filters === void 0 ? void 0 : filters.pointers) && (filters === null || filters === void 0 ? void 0 : filters.pointers.length) > 0);
        if (!filtersAreSet) {
            throw new Error(`When fetching deployments, you must set at least one filter that isn't 'onlyCurrentlyPointed'`);
        }
    }
    sortingToQueryParams(sort) {
        const sortQueryParams = new Map();
        if (sort === null || sort === void 0 ? void 0 : sort.field) {
            sortQueryParams.set('sortingField', [sort.field]);
        }
        if (sort === null || sort === void 0 ? void 0 : sort.order) {
            sortQueryParams.set('sortingOrder', [sort.order]);
        }
        return sortQueryParams;
    }
    isContentAvailable(cids, options) {
        if (cids.length === 0) {
            return Promise.reject(`You must set at least one cid.`);
        }
        return Helper_1.splitAndFetch({
            fetcher: this.fetcher,
            baseUrl: this.contentUrl,
            path: `/available-content`,
            queryParams: { name: 'cid', values: cids },
            uniqueBy: 'cid',
            options
        });
    }
    getContentUrl() {
        return this.contentUrl;
    }
    /** Given an array of file hashes, return a set with those already uploaded on the server */
    async hashesAlreadyOnServer(hashes, options) {
        const result = await this.isContentAvailable(hashes, options);
        const alreadyUploaded = result.filter(({ available }) => available).map(({ cid }) => cid);
        return new Set(alreadyUploaded);
    }
    fetchJson(path, options) {
        return this.fetcher.fetchJson(`${this.contentUrl}${path}`, options);
    }
}
exports.ContentClient = ContentClient;
ContentClient.CHARS_LEFT_FOR_OFFSET = 7;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
class DeploymentFields {
    constructor(fields) {
        this.fields = fields;
    }
    getFields() {
        return this.fields.join(',');
    }
    isFieldIncluded(name) {
        return this.fields.includes(name);
    }
}
exports.DeploymentFields = DeploymentFields;
DeploymentFields.AUDIT_INFO = new DeploymentFields(['auditInfo']);
DeploymentFields.POINTERS_CONTENT_METADATA_AND_AUDIT_INFO = new DeploymentFields([
    'pointers',
    'content',
    'metadata',
    'auditInfo'
]);
DeploymentFields.POINTERS_CONTENT_AND_METADATA = new DeploymentFields([
    'pointers',
    'content',
    'metadata'
]);
//# sourceMappingURL=ContentClient.js.map